module.exports = __webpack_public_path__ + "img/lift1.7e3eb105.jpg";